import { Collapse as AntCollapse } from 'antd';
import styled from 'styled-components';

const Collapse = styled(AntCollapse)``;

export default Collapse;
